import { render, staticRenderFns } from "./LoginIndex.vue?vue&type=template&id=1bf358c6"
import script from "./LoginIndex.vue?vue&type=script&lang=js"
export * from "./LoginIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports